import React from 'react'
import makeStyles from '@mui/styles/makeStyles'
import { alpha } from '@mui/material/styles'
import classNames from 'classnames'
import { DatePicker } from '@carsys/ui'
import { NullableDate } from './date.d'
import { outlinedInputClasses, svgIconClasses } from '@mui/material'

const useStyles = makeStyles(theme => ({
  appBarElement: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.contrastText,
    [`& .${outlinedInputClasses.disabled}`]: {
      color: 'rgba(0, 0, 0, 0.38) !important',
      '& fieldset': {
        borderColor: 'rgba(0, 0, 0, 0.38) !important'
      }
    },
    [`& .${outlinedInputClasses.root}`]: {
      '& fieldset': { borderColor: alpha(theme.palette.primary.contrastText, 0.4) }
    },
    [`& .${svgIconClasses.root}`]: {
      color: alpha(theme.palette.primary.contrastText, 0.4)
    },

    [`& :hover, & .${outlinedInputClasses.focused}`]: {
      [`&.${outlinedInputClasses.root}`]: {
        '& fieldset': { borderColor: theme.palette.primary.contrastText }
      },
      [`& .${svgIconClasses.root}`]: {
        color: theme.palette.primary.contrastText
      }
    }
  },
  appBarLabel: {
    color: alpha(theme.palette.primary.contrastText, 0.7),
    [`& .${outlinedInputClasses.focused}`]: {
      color: theme.palette.primary.contrastText
    }
  },
  appBarInput: {
    color: theme.palette.primary.contrastText,

    '&:focus': {
      color: theme.palette.primary.contrastText,
      '& fieldset': { borderColor: theme.palette.primary.contrastText }
    },
    '&:hover': {
      color: theme.palette.primary.contrastText
    }
  }
}))

interface IDatePickerProps {
  label: string
  value: NullableDate
  className?: string
  disabled: boolean
  onChange: (value: NullableDate) => void
}

const AppBarDatePicker: React.FC<IDatePickerProps> = ({ onChange, value, label, className, disabled }: IDatePickerProps) => {
  const classes = useStyles()

  return (
    <DatePicker
      className={classNames(classes.appBarElement, className)}
      slotProps={{
        textField: {
          helperText: null,
          InputLabelProps: { className: classes.appBarLabel },
          inputProps: { className: classes.appBarInput },
          fullWidth: false,
          color: 'primary'
        }
      }}
      value={value}
      label={label}
      disabled={disabled}
      onChange={onChange}
    />
  )
}

export default AppBarDatePicker
